import { useInfiniteQuery, useQuery } from "react-query";
import {
  getCardByUserId,
  getLoyaltyHistory,
  getOneLoyaltyHistory,
} from "~/services/loyalty.service";
import {
  GetTransactionsParams,
  IResponsesGetCard,
  MesraTransactionItem,
} from "~/lib/types/loyalty.type";
import { GetOneTransaction } from "~/lib/types/variables.type";

const LOYALTY_QUERY_KEY = {
  GET_LOYALTY_TRANSACTIONS: "GET_LOYALTY_TRANSACTIONS",
  GET_ONE_LOYALTY_TRANSACTION: "GET_ONE_LOYALTY_TRANSACTION",
  GET_MESRA_POINT: "GET_MESRA_POINT",
} as const;

export const useMesraHistory = (params?: GetTransactionsParams) =>
  useQuery(
    [LOYALTY_QUERY_KEY.GET_LOYALTY_TRANSACTIONS, params],
    () =>
      getLoyaltyHistory(params).then((res) =>
        res.data.map((item: MesraTransactionItem) => ({
          ...item,
          isMesra: true,
        }))
      ),
    {
      enabled: params?.enabled,
    }
  );

export const useInfiniteMesraHistory = (params?: GetTransactionsParams) =>
  useInfiniteQuery(
    ["infinite", LOYALTY_QUERY_KEY.GET_LOYALTY_TRANSACTIONS, params],
    ({ pageParam }) => {
      return getLoyaltyHistory({ ...params, nextToken: pageParam }).then(
        (res) => {
          return {
            ...res,
            data: res.data.map((item: MesraTransactionItem) => ({
              ...item,
              isMesra: true,
            })),
          };
        }
      );
    },
    {
      enabled: params?.enabled,
      getNextPageParam: (lastPage) => lastPage.nextToken,
    }
  );

export const useOneMesraHistory = (params?: GetOneTransaction) =>
  useQuery(
    [LOYALTY_QUERY_KEY.GET_ONE_LOYALTY_TRANSACTION, params],
    () =>
      getOneLoyaltyHistory(params).then((res) => ({ ...res, isMesra: true })),
    {
      enabled: params?.enabled,
    }
  );

export const useGetMesraPoints = (userId?: string) =>
  useQuery([LOYALTY_QUERY_KEY.GET_MESRA_POINT, userId], () =>
    userId
      ? getCardByUserId(userId).then(
          (res: IResponsesGetCard) => res?.pointBalance
        )
      : null
  );
